export default __webpack_public_path__ + "static/media/lyndys.b24bf809.svg";